var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.listOfMetadataRepresentations.length > 0
      ? _c(
          "div",
          { staticClass: "panel panel-default table-of-contents margin-above" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._l(
              _vm.listOfMetadataRepresentations,
              function (content, contentIndex) {
                return _c(
                  "div",
                  { key: contentIndex, staticClass: "list-style-type-none" },
                  [_c("table-element", { attrs: { content: content } })],
                  1
                )
              }
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", [_vm._v("Jump to items")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }